import { render, staticRenderFns } from "./DoctorHome.vue?vue&type=template&id=0f3045c4&scoped=true&"
import script from "./DoctorHome.vue?vue&type=script&lang=js&"
export * from "./DoctorHome.vue?vue&type=script&lang=js&"
import style0 from "./DoctorHome.vue?vue&type=style&index=0&id=0f3045c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3045c4",
  null
  
)

export default component.exports